import { render, staticRenderFns } from "./SaldosModal.vue?vue&type=template&id=78fd5bfa&scoped=true"
import script from "./SaldosModal.vue?vue&type=script&lang=ts"
export * from "./SaldosModal.vue?vue&type=script&lang=ts"
import style0 from "./SaldosModal.vue?vue&type=style&index=0&id=78fd5bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd5bfa",
  null
  
)

export default component.exports